import Vue from 'vue'
import Vuex from 'vuex'
import * as MUTATION from './const.mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mousePosition: {x: 0, y: 0},
    scrollTop: 0,
    globalData: null,
    angle: null
  },
  mutations: {
    [MUTATION.SET_MOUSE_POSITION] (state, pos) {
      state.mousePosition = pos
    },
    [MUTATION.SET_SCROLL_TOP] (state, top) {
      state.scrollTop = top
    },
    [MUTATION.SET_GLOBAL_DATA] (state, data) {
      state.globalData = data
    },
    [MUTATION.SET_ANGLE] (state, data) {
      state.angle = data
    }
  },
  actions: {
    setMousePosition ({ state, commit }, pos) {
      commit(MUTATION.SET_MOUSE_POSITION, pos)
    },
    setScrollTop({ state, commit }, top) {
      commit(MUTATION.SET_SCROLL_TOP, top)
    },
    setGlobalData({ state, commit }, data) {
      commit(MUTATION.SET_GLOBAL_DATA, data)
    },
    setAngle({ state, commit }, data) {
      commit(MUTATION.SET_ANGLE, data)
    }
  },
  getters: {
    getMousePosition (state) {
      return state.mousePosition
    },
    getScrollTop(state){
      return state.scrollTop
    },
    getGlobalData(state)
    {
      return state.globalData
    },
    getAngle(state)
    {
      return state.angle
    }
  }
})
